var Constant = {
  sceneState: {
    enterModelPlayerScale: 1, //进入模型时角色的缩放比例
    // Lights
    addLights: true,
    exposure: 1.5,
    textureEncoding: "sRGB",
    //bgColor1: '#dbe0e6',
    bgColor2: "#667294",
    bgColor1: "#667294",
  },

  MAP_NAMES: [
    "map",
    "aoMap",
    "emissiveMap",
    "glossinessMap",
    "metalnessMap",
    "normalMap",
    "roughnessMap",
    "specularMap",
  ],
};

export { Constant };
